import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
    PH2,
    PLink,
    PText,
    PBox,
    PHighlightButton,
} from "../../theme/BaseTheme";
import { AuthenticationLayout } from "./AuthenticationLayout";
import { resendVerification } from "../../../actions/auth";

class RegistrationSuccess extends Component {
    componentDidMount() {}
    render() {
        return (
            <AuthenticationLayout>
                <PBox css={styles}>
                    <PBox className="title">
                        <PH2>Registration Success</PH2>
                    </PBox>
                    <PBox className="registration-success">
                        <PBox className="registration-success-title">
                            <PBox>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="64"
                                    height="64"
                                    fill="#000000"
                                    viewBox="0 0 256 256"
                                >
                                    <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path>
                                </svg>
                            </PBox>
                            <PText>
                                Thank you. We have sent you a verification email
                                to <b>{this.props.userEmail?.email}</b>. Please
                                click the link in that message to activate your
                                account.
                            </PText>
                        </PBox>
                        <PHighlightButton
                            type="primary"
                            htmlType="submit"
                            size="large"
                            className="registration-success-button"
                            onClick={() => {
                                this.props.history.push("/sign-in");
                            }}
                        >
                            Log In
                        </PHighlightButton>
                    </PBox>
                    <PBox className="resend-link">
                        <PText>
                            Didn't receive an email?{" "}
                            <PLink
                                className="resend-link"
                                onClick={() => {
                                    this.props.resendVerification(
                                        this.props.userEmail?.email
                                    );
                                }}
                            >
                                Resend
                            </PLink>
                        </PText>
                    </PBox>
                </PBox>
            </AuthenticationLayout>
        );
    }
}

const styles = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& .registration-success": {
        width: "400px",
        marginTop: "2rem",
        backgroundColor: "#fff",
        padding: "3rem 2rem 2rem 2rem",
        borderRadius: "0.5rem",
        boxShadow:
            "0 0 #0000, 0 0 #0000, 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    },
    "& h2": {
        color: "$colors$text",
        textAlign: "center",
        margin: "20px 0",
        fontWeight: "600",
    },
    "& p": {
        color: "$colors$text",
        textAlign: "center",
        lineHeight: "24px",
        margin: "4px 0",
    },
    "& a": {
        color: "$colors$primary",
        "&:hover": {
            color: "#000",
            cursor: "pointer",
        },
    },
    "& .title": {
        fontSize: "18px",
        marginTop: "2rem",
    },
    "& .registration-success-button": {
        color: "#fff",
        backgroundColor: "$colors$primary700",
        width: "100%",
        borderColor: "$colors$primary700",
        marginTop: "16px",
        borderRadius: "8px",
        "&:hover": {
            backgroundColor: "$colors$primary500",
            borderColor: "$colors$primary500",
        },
        margin: "20px 0",
    },
    "& .registration-success-title": {
        marginBottom: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "& h2": {
            fontWeight: "400",
        },
        "& svg": {
            backgroundColor: "#fff",
            borderRadius: "100px",
            fill: "$colors$primary",
            marginBottom: "2rem",
        },
    },
    "& .resend-link": {
        marginTop: "2.5rem",
        fontSize: "16px",
        "& a": {
            color: "$colors$primary700",
            textDecoration: "none",
            fontWeight: "600",
            "&:hover": {
                color: "$colors$primary500",
            },
        },
    },
};

function mapStateToProps(state) {
    return {
        userEmail: state.authReducer?.verifyToken?.userEmail,
    };
}
export default connect(mapStateToProps, { resendVerification })(
    withRouter(RegistrationSuccess)
);
